import { render, staticRenderFns } from "./PersonGroupEdit.vue?vue&type=template&id=5f1704f6&"
import script from "./PersonGroupEdit.vue?vue&type=script&lang=js&"
export * from "./PersonGroupEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports